import { Box, Typography } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";
import LoanFormPopupV2 from "../../src/Drawer/LoanFormPopupV2";
import { MemoizedConnectDrawer } from "../../src/Drawer/connectDrawer";
import {
  generateItemListSchema,
  createListItem,
} from "../../src/utils/ItemListSchema.js";
import {
  mahindraPrdouctSchema,
  piaggioPrdouctSchema,
} from "../../src/constants/productSchema";
import {
  searchWebSiteVehicles,
  webPageSpeakableVehicles,
} from "../../src/constants/siteLinksSchems";
import { convertFAQsToQuestions, generateFAQPageSchema } from "../../src/utils/FAQPageSchemaGenerator.js";
import { ElectricCommercialVehiclePageFAQ } from "../../src/constants/faq";
import {
  BrandLogos,
  newVehicles,
  vehicles,
} from "../../src/constants/vehicleData";
import { imagesWEBP } from "../../src/constants/webpImages";
import { MemoizedFooter } from "../../src/layouts/footer";
import { MemoizedHeader } from "../../src/layouts/header";
import WhatsAppFloater from "../../src/modules/Brand/WhatAppFloater";
import BookEVConsultationForm from "../../src/modules/Home/BookEVconsult/bookEVConsultation";
import FullscreenDrawer from "../../src/modules/Home/HomePageRevamp/VehicleSlideDrawer";
import { MemoizedFAQ } from "../../src/modules/Lead Capture/FAQ/faq";
import QlDrawerComponent from "../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import MemoizedTopBanner from "../../src/modules/Vehicles/Banner/BannerGeneric";
import BrandLogoTile from "../../src/modules/Vehicles/Banner/BrandLogoTile";
import SeoContentRenderer from "../../src/components/common/ContentTemplates/SeoContentRenderer";
import AtfContentSection from "../../src/components/common/ContentTemplates/AtfContentSection";
import SeoContentSection from "../../src/components/common/ContentTemplates/SeoContentSection";
import { MemoizedVehicles } from "../../src/modules/Vehicles/Vehicles";
import MemoizedSearchHeader from "../../src/modules/Vehicles/searchHeader";
import { sendAnalytics } from "../../src/utils/analyticsCommon";
import {
  TITLE,
  META_CONTENT,
  VEHICLE_LINK,
  H1_HEADING,
  ATF_CONTENT,
  POPULAR_VEHICLES_HEADING,
  POPULAR_VEHICLES_TABLE,
  SEO_FOOTER_CONTENT,
  CONNECT_HEADING,
  CONNECT_SUBHEADING,
  CONNECT_CTA_TEXT,
  VEHICLE_CATEGORY_HEADING,
  VEHICLE_CATEGORY_OPTIONS,
} from "../../src/constants/electricCommericalVehicle/index.js";
import CategorySelector from "../../src/components/common/CategorySelector";

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: VEHICLE_LINK,
    },
  ],
};

export default function ElectricCommercialVehicle({ vehiclesByBrand, itemListSchema, faqPageSchema, BrandLogos: filteredBrandLogos }) {

  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: "electric_commercial_vehicle" },
      "en"
    );
  }, []);

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <meta name="google-site-verification" content="Z4WHXzpop_N_b6hE5g7A0fCENRwj5VqC3nSEsXLaQ3Y" />
        <link rel="canonical" href={VEHICLE_LINK} />
        {/* FAQPage Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqPageSchema),
          }}
          defer
        />
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(webPageSpeakableVehicles),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(searchWebSiteVehicles),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(piaggioPrdouctSchema),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(mahindraPrdouctSchema),
          }}
          defer
        /> */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(itemListSchema),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadcrumbSchema),
          }}
          defer
        />
      </Head>
      <body>
        <Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader />
          </Box>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          <FullscreenDrawer />
          <LoanFormPopupV2 />
          <QlDrawerComponent />
          <MemoizedTopBanner
            bannerData={{
              desktopImg: imagesWEBP?.vehiclePageBanner,
              mobileImg: imagesWEBP?.allBrandsBanner,
              alt: "Top Banner for Electric Commercial Vehicles",
            }}
          />

          <Box sx={{ display: { sm: "block", md: "none", lg: "none" } }}>
            {" "}
            <BookEVConsultationForm />
          </Box>

          <Typography
            variant="h1"
            style={{ fontSize: "34px", fontWeight: 700, paddingLeft: "8%" }}
          >
            {H1_HEADING}
          </Typography>

          {/* ATF Content */}
          <AtfContentSection
            content={ATF_CONTENT}
            tableData={{
              heading: POPULAR_VEHICLES_HEADING,
              vehiclesData: POPULAR_VEHICLES_TABLE,
            }}
          />

          <BrandLogoTile brand="" BrandLogos={filteredBrandLogos || []} />
          <MemoizedVehicles vehiclesByBrand={vehiclesByBrand} />
          {/* <Content /> */}
          
          {/* SEO Footer Content with Read More/Less */}
          <SeoContentSection>
            <SeoContentRenderer content={SEO_FOOTER_CONTENT} />
          </SeoContentSection>

           <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "40px auto", padding: { xs: "0 12px", md: "0" } }}>
            <CategorySelector
              heading={VEHICLE_CATEGORY_HEADING}
              categories={VEHICLE_CATEGORY_OPTIONS}
            />
          </Box>

          <MemoizedFAQ  faqList={ElectricCommercialVehiclePageFAQ}/>
          <WhatsAppFloater />
          <MemoizedConnectDrawer
            heading={CONNECT_HEADING}
            subHeading={CONNECT_SUBHEADING}
            ctaText={CONNECT_CTA_TEXT}
          />
          <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
            <Breadcrumbs
              items={[
                { label: "Home", href: "/" },
                { label: "Electric Commercial Vehicles" },
              ]}
            />
          </Box>
          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
}
export const getStaticProps = (context) => {
  let allVehicles = [...vehicles, ...newVehicles];
  const updatedVehiclesByBrand = {};
  //soting vehicles by brands
  allVehicles?.forEach((vehicle) => {
    // if(vehicle?.type==="passenger")
    //   return;
    const brand = vehicle?.brand?.toLowerCase();
    // Exclude Eka, Altigreen, and Etrio brands
    if (brand === "eka" || brand === "altigreen" || brand === "etrio") {
      return;
    }
    if (!updatedVehiclesByBrand?.hasOwnProperty(brand)) {
      updatedVehiclesByBrand[brand] = [];
    }
    updatedVehiclesByBrand[brand]?.push(vehicle);
  });

  // Generate ItemList Schema for all vehicles
  const itemListSchema = generateItemListSchema({
    name: "Electric Commercial Vehicles",
    description: "List of electric commercial vehicles available at Turno",
    itemListElement: allVehicles.map((vehicle, index) => {
      const vehicleUrl = vehicle.vehicle_path_id 
        ? `https://www.turno.club/electric-commercial-vehicles/${vehicle.brand}/${vehicle.vehicle_path_id}`
        : `https://www.turno.club/electric-commercial-vehicles/${vehicle.brand}`;
      
      return createListItem({
        position: index + 1,
        name: vehicle.name || vehicle.vehicle_name || `${vehicle.brand} ${vehicle.vehicle_path_id}`,
        url: vehicleUrl,
        description: vehicle.meta_description || vehicle.page_title || `${vehicle.brand} ${vehicle.vehicle_name || vehicle.vehicle_path_id} electric commercial vehicle`,
        image: vehicle.image || vehicle.storeImage || vehicle.homeImage,
      });
    }),
    itemListOrder: "Ascending",
    numberOfItems: allVehicles.length,
    url: VEHICLE_LINK,
  });

  // Generate FAQPage Schema from ElectricCommercialVehiclePageFAQ
  const faqQuestions = convertFAQsToQuestions(ElectricCommercialVehiclePageFAQ || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: "FAQs on Electric Commercial Vehicles",
    description: `Frequently asked questions about electric commercial vehicles.`,
    url: VEHICLE_LINK,
    headline: "FAQs on Electric Commercial Vehicles",
    keywords: META_CONTENT[1]?.content || "Electric Commercial Vehicles, FAQ, electric vehicles",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: breadcrumbSchema,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: imagesWEBP?.vehiclePageBanner || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
  });

  // Filter BrandLogos to exclude Eka, Altigreen, and Etrio
  const filteredBrandLogos = BrandLogos?.filter((logo) => {
    const brandName = logo?.BrandName?.toLowerCase();
    return brandName !== "eka" && brandName !== "altigreen" && brandName !== "etrio" && brandName !== "4w/eka/k1.5";
  });

  return {
    props: { 
      vehiclesByBrand: updatedVehiclesByBrand,
      itemListSchema,
      faqPageSchema,
      BrandLogos: filteredBrandLogos },
  };
};
